export const environment = {
    production: false,
    apiUrl: 'https://lemunzo-dev-container-epa7etc2ffh9h4fn.germanywestcentral-01.azurewebsites.net/api/',
    uploadWorkerUrl:
        'https://lemunzo-dev-upload-worker-g2gea8gvhnh2hhdk.germanywestcentral-01.azurewebsites.net/api/',
    publicWebsiteUrl: 'https://www.litfin.capital/en/cases',
    authConfig: {
        // points to Staging External Entra ID => PROD uses PROD External Entra ID
        clientId: '1beead90-ddef-4a38-a8d7-649b92bff13e',
        authority:
            'https://15f1d6bf-7430-4e0d-aef0-b7934c717d28.ciamlogin.com/15f1d6bf-7430-4e0d-aef0-b7934c717d28',
        apiConfig: {
            scopes: [
                'api://1beead90-ddef-4a38-a8d7-649b92bff13e/Lemunzo.Client.FE',
            ],
            uri: 'https://lemunzo-dev-container-epa7etc2ffh9h4fn.germanywestcentral-01.azurewebsites.net/api',
            unprotected: [
                '/cases/public',
                '/client-registrations/public',
                '/localization/public',
            ],
        },
    },
};
